export default __webpack_public_path__ + "static/leverOff-a9bad8b29850286f70635d00b7f4b468.png";